// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"296":"final","443":"about"}[chunkId] + "." + {"296":"634df56d","443":"34743998"}[chunkId] + ".css";
};